import React from 'react';
import ActionButtonView, { ActionButtonViewProps } from './ActionButtonView/ActionButtonView';

export interface ActionButtonPresenterProps {
  onOpenModal: () => void;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  variant?: 'primary' | 'secondary' | 'tercery';
  label?: string;
}

export default function ActionButtonPresenter({
  onOpenModal,
  disabled = false,
  size = 'medium',
  variant = 'primary',
  label
}: ActionButtonPresenterProps) {
  const handleClick = () => {
    if (!disabled) {
      onOpenModal();
    }
  };

  const viewProps: ActionButtonViewProps = {
    onClick: handleClick,
    disabled,
    size,
    variant,
    label
  };

  return <ActionButtonView {...viewProps} />;
}
